<template>
    <div class="reporting-frame">
        <h2 class="page-title">Reporting</h2>

        <div class="filters">
            <div>
                <label>Période</label>
                <select v-model="period">
                    <option v-for="(period, key) in periods" :key="key" :value="key">{{ period }}</option>
                </select>
            </div>

            <div>
                <label>Administrateur</label>
                <select v-model="adminId">
                    <option v-for="(admin, index) in adminsList" :key="index" :value="admin.id">{{ admin.name }}</option>
                </select>
            </div>
        </div>

        <div class="container">
            <div>
                <div class="stats-section">
                    <div class="stat-frame"> <span>{{ nb_events }}</span> évènements</div>
                    <div class="stat-frame"> <span>{{ nb_calls }}</span> appels passés</div>
                    <div class="stat-frame"> <span>{{ nb_email }}</span> mails envoyés</div>
                    <div class="stat-frame"> <span>{{ nb_visio }}</span> visios réalisées</div>
                    <div class="stat-frame"> <span>{{ nb_rdv }}</span> rendez-vous physiques</div>
                    <div class="stat-frame"> <span>{{ nb_clients }}</span> cabinets clients</div>
                </div>
            </div>


            <div class="event-section">
                <table class="event-table">
                    <tr>
                        <td class="header" colspan=5>Evenements de la période</td>
                    </tr>

                    <tr v-for="(event, index) in formatedEventList" :key="index" @click="selectEvent(event)">
                        <td>{{ index + 1 }}</td>
                        <td>{{ $store.getters.eventTypes[event.type] || event.type }}</td>
                        <td>{{ event.title }}</td>
                        <td>{{ event.directorName }}</td>
                        <td>{{ dateToString(event.date) }}</td>
                        <modale :show="showEventDetail && selectedEvent._id == event._id" @toggle="toggleShowEvent">
                            <div class="action-detail" v-html="event.text"></div>
                        </modale>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            periods: {
                today: "Aujourd'hui",
                yesterday: "Hier",
                week: "Cette semaine",
                month: "Ce mois-ci",
                last_month: "Le mois dernier",
                year: "Cette année"
            },
            period: "",
            events: [],
            nb_clients: 0,
            selectedEvent: {},
            showEventDetail: false,
            adminId: undefined,
            adminsList: [],
        }
    },
    methods: {
        async loadEvents() {
            const res = await axios.post(this.$store.getters.get_api_url + "crm/all-events", this.request)
            this.events = res.data
        },
        isCommand(event) {
            if (event.type == 'Commande') {
                return true
            } else {
                return false
            }
        },
        toggleShowEvent() {
            this.showEventDetail = !this.showEventDetail
        },
        selectEvent(event) {
            this.selectedEvent = event
            this.toggleShowEvent()
        }
    },
    computed: {
        date_range() {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const period = this.period;
            const startOf = {
                today: () => ({ start: new Date(today) }),

                yesterday: () => {
                    const yesterday = new Date(today);
                    yesterday.setDate(yesterday.getDate() - 1);
                    return { start: yesterday, end: today };
                },

                week: () => {
                    const day = today.getDay();
                    const diff = today.getDate() - day + (day === 0 ? -6 : 1); // lundi
                    const start = new Date(today);
                    start.setDate(diff);
                    return { start };
                },

                month: () => {
                    return { start: new Date(today.getFullYear(), today.getMonth(), 1) };
                },

                last_month: () => {
                    const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                    const end = new Date(today.getFullYear(), today.getMonth(), 0);
                    return { start, end };
                },

                year: () => {
                    return { start: new Date(today.getFullYear(), 0, 1) };
                },
            };

            return period in startOf ? startOf[period]() : {};
        },
        request() {
            let result = {
                ...this.date_range,
            }

            if (this.adminId) result.adminId = this.adminId;

            return result;
        },
        nb_rdv() {
            let filtered = this.events.filter(event => event.type == "meeting")
            return filtered.length
        },
        nb_calls() {
            let filtered = this.events.filter(event => event.type == "call")
            return filtered.length
        },
        nb_email() {
            let filtered = this.events.filter(event => event.type == "email")
            return filtered.length
        },
        nb_visio() {
            let filtered = this.events.filter(event => event.type == "visio")
            return filtered.length
        },
        nb_events() {
            return this.formatedEventList.length
        },
        formatedEventList() {
            let result = JSON.parse(JSON.stringify(this.events));
            return result.sort((a, b) => new Date(b.date) - new Date(a.date));
        },
    },
    watch: {
        period() {
            this.loadEvents();
        },
        adminId() {
            this.loadEvents();
        }
    },
    async mounted() {
        this.period = "month"

        const adminRes =  await axios.get(this.$store.getters.get_api_url + "auth/all?active=true&&crmAdminOnly=true")
        this.adminsList = [
            { id: undefined, name: '--' },
            ...adminRes.data.map(admin => {
                return {id: admin._id, name: `${ admin.firstname } ${ admin.lastname }`};
            }),
        ];

        this.adminId = this.$store.getters.getUserId;

        const res = await axios.get(this.$store.getters.get_api_url + "crm/nb-clients")
        this.nb_clients = res.data
    }
}
</script>

<style scoped>
.reporting-frame {
    padding: 20px 20%;
}

.page-title {
    color: rgb(0, 0, 73);
    font-size: 30px;
    margin: 15px;
    border-bottom: 1px solid lightgrey;
}

.filters {
    display: flex;
    justify-content: flex-start;
    margin: 20px 0;
}

.filters div {
    margin: 0 10px;
    display: flex;
    flex-direction: column;
    font-weight: bold;
}

.filters select {
    padding: 5px;
    border: solid 1px lightgrey;
    border-radius: 5px;
}

.container {
    display: flex;
}

.stats-section {
    flex-basis: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}

.stat-frame {
    flex-basis: 25%;
    margin: 10px 10px;
    background-color: white;
    border-radius: 10px;
    padding: 15px;
    display: flex;
    align-items: center;
}

.stat-frame span {
    font-size: 22px;
    font-weight: bold;
    color: rgb(255, 128, 0);
    margin-right: 10px;
}

.event-section {
    flex-basis: 100%;
}

.event-table {
    width: 100%;
    background-color: white;
    border-radius: 10px;
    border-collapse: collapse;
}

.event-table .header {
    padding: 10px;
    text-align: center;
    background-color: rgb(2, 2, 95);
    color: white;
    border-radius: 10px 10px 0 0;
    font-size: 15px;
}

.event-table td {
    cursor: pointer;
    padding: 5px;
    border: solid 1px rgb(243, 245, 247);
    font-size: 12px;
}

.action-detail {
    padding: 20px;
}
</style>